import React from 'react'
import { Alert, Button } from 'antd'
import { Icons } from '../../Shared/Icons'
import { ErrorType } from '../../../models/aiAnalysis/workflow'
import styles from './styles.module.scss'

export interface AiDraftErrorDisplayProps {
  error: string
  errorType: ErrorType
  onDismiss: () => void
}

const BUTTON_TEXT: Record<ErrorType, string> = {
  [ErrorType.ALREADY_DECIDED]: 'Refresh',
  [ErrorType.RETRYABLE]: 'Try again',
  [ErrorType.FATAL]: 'Close'
}

const ERROR_TITLE: Record<ErrorType, string> = {
  [ErrorType.ALREADY_DECIDED]: 'Message not sent',
  [ErrorType.RETRYABLE]: 'Could not send',
  [ErrorType.FATAL]: 'Could not send'
}

const AiDraftErrorDisplay: React.FC<AiDraftErrorDisplayProps> = ({ error, errorType, onDismiss }) => {
  const buttonText = BUTTON_TEXT[errorType]
  const title = ERROR_TITLE[errorType]

  return (
    <div className={styles.errorOnlyContainer}>
      <Alert
        message={title}
        description={error}
        type="error"
        showIcon
        icon={<Icons.CloseCircle />}
        className={styles.errorAlert}
      />
      <div className={styles.errorActions}>
        <Button onClick={onDismiss} type="primary" className={styles.errorButton}>
          {buttonText}
        </Button>
      </div>
    </div>
  )
}

export default AiDraftErrorDisplay
